import {
  MultimediaFilterValues,
  MultimediaGetResponse,
  MultimediaParams,
  MultimediaValues,
} from '../model/multimediaModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

export enum MULTIMEDIA_TYPES {
  SET_API_MULTIMEDIA_REQUEST_STATE = 'SET_API_MULTIMEDIA_REQUEST_STATE',
  SET_API_MULTIMEDIA_REQUEST_ERROR = 'SET_API_MULTIMEDIA_REQUEST_ERROR',
  SET_API_ALL_MULTIMEDIA_REQUEST_STATE = 'SET_API_ALL_MULTIMEDIA_REQUEST_STATE',
  SET_API_ALL_MULTIMEDIA_REQUEST_ERROR = 'SET_API_ALL_MULTIMEDIA_REQUEST_ERROR',
  ADD = 'MULTIMEDIA_ADD',
  DELETE = 'MULTIMEDIA_DELETE',
  EDIT = 'MULTIMEDIA_EDIT',
  GET_ALL = 'MULTIMEDIA_GET_ALL',
  GET_ALL_SUCCESS = 'MULTIMEDIA_GET_ALL_SUCCESS',
  GET_ONE = 'MULTIMEDIA_GET_ONE',
  GET_ONE_SUCCESS = 'MULTIMEDIA_GET_ONE_SUCCESS',
  RESET = 'MULTIMEDIA_RESET',
}

export interface SetApiMultimediaRequestStateAction {
  type: MULTIMEDIA_TYPES.SET_API_MULTIMEDIA_REQUEST_STATE;
  payload: {
    apiMultimediaRequestState: API_REQUEST_STATE;
  };
}

export interface SetApiMultimediaRequestErrorAction {
  type: MULTIMEDIA_TYPES.SET_API_MULTIMEDIA_REQUEST_ERROR;
  payload: {
    apiMultimediaRequestError: string;
  };
}

export interface SetApiAllMultimediaRequestStateAction {
  type: MULTIMEDIA_TYPES.SET_API_ALL_MULTIMEDIA_REQUEST_STATE;
  payload: {
    apiAllMultimediaRequestState: API_REQUEST_STATE;
  };
}

export interface EditMultimediaAction {
  type: MULTIMEDIA_TYPES.EDIT;
  payload: {
    multimedia: MultimediaValues;
    params: MultimediaParams;
  };
}

export interface DeleteMultimediaAction {
  type: MULTIMEDIA_TYPES.DELETE;
  payload: {
    params: MultimediaParams;
  };
}

export interface SetApiAllMultimediaRequestErrorAction {
  type: MULTIMEDIA_TYPES.SET_API_ALL_MULTIMEDIA_REQUEST_ERROR;
  payload: {
    apiAllMultimediaRequestError: string;
  };
}

export interface AddMultimediaAction {
  type: MULTIMEDIA_TYPES.ADD;
  payload: {
    multimedia: MultimediaValues;
  };
}

export interface GetOneMultimediaAction {
  type: MULTIMEDIA_TYPES.GET_ONE;
  payload: {
    params: MultimediaParams;
  };
}

export interface ResetMultimediaAction {
  type: MULTIMEDIA_TYPES.RESET;
  payload: null;
}

export interface GetOneMultimediaSuccessAction {
  type: MULTIMEDIA_TYPES.GET_ONE_SUCCESS;
  payload: {
    multimedia: MultimediaGetResponse;
  };
}

export interface GetAllMultimediaAction {
  type: MULTIMEDIA_TYPES.GET_ALL;
  payload: {
    multimediaFilter: MultimediaFilterValues;
  };
}

export interface GetAllMultimediaSuccessAction {
  type: MULTIMEDIA_TYPES.GET_ALL_SUCCESS;
  payload: {
    multimedia: MultimediaGetResponse[];
  };
}

export type MultimediaActions =
  | SetApiMultimediaRequestStateAction
  | SetApiMultimediaRequestErrorAction
  | SetApiAllMultimediaRequestStateAction
  | SetApiAllMultimediaRequestErrorAction
  | ResetMultimediaAction
  | AddMultimediaAction
  | EditMultimediaAction
  | DeleteMultimediaAction
  | GetOneMultimediaAction
  | GetOneMultimediaSuccessAction
  | GetAllMultimediaAction
  | GetAllMultimediaSuccessAction;

export interface MultimediaState {
  apiMultimediaRequestState: API_REQUEST_STATE;
  apiMultimediaRequestError: string | null;
  apiAllMultimediaRequestState: API_REQUEST_STATE;
  apiAllMultimediaRequestError: string | null;
  multimedia: MultimediaGetResponse;
  allMultimedia: MultimediaGetResponse[];
}
